import { useEffect, useRef } from 'react';

import { FAQ } from '@components/FAQ';
import { useIsInView } from '@hooks/useIsInView';
import { useTrackingContext } from '@tracking/Provider/Context';
import {
  useTrackSignupBhcFaqExpanded,
  useTrackSignupBhcFaqsDisplayed,
} from '@tracking/trackingEvents';

import { getFaqSections } from './sections';

const BHCFAQ = () => {
  const ref = useRef<HTMLElement>(null);
  const isInView = useIsInView(ref);

  const { trackingContexts } = useTrackingContext();
  const trackExpanded = useTrackSignupBhcFaqExpanded();
  const trackDisplayed = useTrackSignupBhcFaqsDisplayed();

  const faqSections = getFaqSections();

  useEffect(() => {
    if (isInView) {
      trackDisplayed({}, { contexts: trackingContexts });
    }
  }, [isInView, trackDisplayed, trackingContexts]);

  const handleAccordionChange = (question: string, isExpanded: boolean) => {
    if (!isExpanded) {
      return;
    }

    trackExpanded(
      {
        question,
      },
      { contexts: trackingContexts }
    );
  };

  return (
    <FAQ
      ref={ref}
      sections={faqSections}
      onAccordionChange={handleAccordionChange}
    />
  );
};

export { BHCFAQ };
